export default __webpack_public_path__ + "static/media/Picture1.18932ec9.png";